export default "__VITE_ASSET__CGk42vWq__"